import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { FASTAPI_ENDPOINT } from "../constant";

const Chat = () => {
  const [query, setQuery] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGetAdvice = async () => {
    if (!query.trim()) {
      setError("Please enter a question to get advice.");
      return;
    }
    setError("");
    setLoading(true);
    setAnswer("");
    try {
      const response = await fetch(FASTAPI_ENDPOINT + "/advice", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.detail || "Failed to fetch advice.");
      }
      setAnswer(data.answer);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "720px",
          backgroundColor: "white",
          boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)",
          borderRadius: "1rem",
          padding: "1.5rem",
        }}
      >
        <h1
          style={{
            fontSize: "1.875rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          Legacy Mental Health Counsellor
        </h1>
        <textarea
          style={{
            width: "100%",
            border: "1px solid #d1d5db",
            borderRadius: "0.5rem",
            padding: "0.75rem",
            marginBottom: "1rem",
            outline: "none",
            resize: "vertical",
          }}
          rows={4}
          placeholder="Enter your question here..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        {error && (
          <p style={{ color: "#f87171", marginBottom: "0.5rem" }}>{error}</p>
        )}
        <button
          style={{
            width: "100%",
            backgroundColor: "#2563eb",
            color: "white",
            padding: "0.5rem",
            borderRadius: "0.5rem",
            border: "none",
            cursor: loading ? "not-allowed" : "pointer",
            transition: "background-color 0.2s ease",
          }}
          onClick={handleGetAdvice}
          disabled={loading}
        >
          {loading ? "Loading..." : "Get Advice"}
        </button>
        {answer && (
          <div style={{ marginTop: "1.5rem", textAlign: 'left' }}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} 
            components={{
                ul: ({ node, ...props }) => (
                    <ul style={{ paddingLeft: "1.5rem", listStyleType: "disc" }} {...props} />
                ),
                ol: ({ node, ...props }) => (
                    <ol style={{ paddingLeft: "1.5rem", listStyleType: "decimal" }} {...props} />
                ),
                li: ({ node, ...props }) => <li style={{ marginBottom: "0.5rem" }} {...props} />,
                }}
            >{answer}</ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
